import React, { useState } from 'react';
import { Bell, MailCheck } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// « Suivre ce chantier » sur la page publique (plan Signature côté entreprise).
// Double opt-in : le visiteur confirme par email. Champ honeypot anti-bot.
export default function FollowButton({ projectSlug, brand = '#2563eb' }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState(''); // honeypot
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/public/chantier/${projectSlug}/follow`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, website }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center',
        padding: '10px 16px', color: '#166534', fontSize: '0.88rem',
      }}>
        <MailCheck size={16} /> Vérifiez votre boîte mail pour confirmer votre suivi.
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: '14px 16px' }}>
      {!open ? (
        <button onClick={() => setOpen(true)} style={{
          display: 'inline-flex', alignItems: 'center', gap: 7,
          background: brand, color: '#fff', border: 'none', borderRadius: 8,
          padding: '9px 18px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer',
        }}>
          <Bell size={15} /> Suivre ce chantier par email
        </button>
      ) : (
        <form onSubmit={submit} style={{ display: 'inline-flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
          {/* Honeypot invisible pour les robots */}
          <input value={website} onChange={e => setWebsite(e.target.value)} tabIndex={-1}
            autoComplete="off" aria-hidden="true"
            style={{ position: 'absolute', left: '-9999px', width: 1, height: 1 }} name="website" />
          <input type="email" required autoFocus value={email}
            onChange={e => setEmail(e.target.value)} placeholder="votre@email.fr"
            style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #cbd5e1', minWidth: 220 }} />
          <button disabled={busy} style={{
            background: brand, color: '#fff', border: 'none', borderRadius: 8,
            padding: '8px 16px', fontSize: '0.88rem', fontWeight: 600, cursor: 'pointer',
          }}>
            {busy ? '...' : "S'abonner"}
          </button>
          {error && <div style={{ width: '100%', color: '#dc2626', fontSize: '0.82rem' }}>{error}</div>}
        </form>
      )}
      <p style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 6 }}>
        Un email par jour maximum en cas d'avancée. Désabonnement en un clic.
      </p>
    </div>
  );
}
